<div
  *transloco="let t; read: 'configurations.analytic-items'"
  class="configuration-route-configurations__form-section"
>
  @if (isConfigLoading) {
    <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  @for (button of typeButtons; track button) {
    <div
      class="configuration-route-configurations__type-button-row"
      [class.configuration-route-configurations__type-button-row--disabled]="
        configurationLimits[button.label].used < 0
      "
    >
      <xi-default-button
        [disabled]="
          configurationLimits[button.label].used < 0 ||
          selectedConfigurationType === 'LT' ||
          selectedConfigurationType === 'IP'
        "
        (onClick)="button.clickHandler()"
        [text]="t(button.i18n)"
        fill="outline"
      >
      </xi-default-button>
      @if (configurationLimits[button.label].used < 0) {
        <span>
          {{ t('analytic-item-not-supported') }}
        </span>
      } @else {
        {{ (configurationLimits[button.label].used | humanizeInt: 1 : 1000) || '…' }} /
        {{ (configurationLimits[button.label].total | humanizeInt: 1 : 1000) || '…' }}
        {{ t('custom') }}
      }
    </div>
  }

  <div
    class="configuration-route-configurations__type-button-link"
    (click)="onAnalyticItemDialogOpened()"
  >
    {{ t('analytic-item-help') }}
  </div>
</div>

@if (showAnalyticItemDialog) {
  <app-lex-xi-modal
    [isVisible]="showAnalyticItemDialog"
    maxWidth="1000px"
    (close)="onAnalyticItemDialogClosed()"
  >
    <ng-template appXIModalContent>
      @if (showAnalyticItemDialog) {
        <app-analytic-type-info-dialog></app-analytic-type-info-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
